import { BadgePercent, X } from "lucide-react";
import { eur } from "../../lib/isde";

const STATUS = { mogelijk: "mogelijk subsidiabel", aanvullend: "aanvullende gegevens nodig", niet: "waarschijnlijk niet subsidiabel" };

// Toont dat de uitkomst van de ISDE-subsidiecheck met de aanvraag wordt meegestuurd.
export const IsdeLinked = ({ isde, onRemove }) => (
  <div className="mb-6 flex items-start gap-3 rounded-2xl border border-gold/30 bg-gold-soft/70 p-4" data-testid="wizard-isde-linked">
    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-white text-gold ring-1 ring-gold/20"><BadgePercent className="h-4 w-4" aria-hidden="true" /></span>
    <div className="min-w-0 flex-1 text-[14px] leading-relaxed text-ink">
      <p className="font-semibold">Uw ISDE-subsidiecheck wordt meegestuurd</p>
      <p className="text-slate-600" data-testid="wizard-isde-summary">
        Kenmerk {isde.isde_check_id} · {STATUS[isde.isde_status] || "indicatie"}{isde.isde_amount != null ? ` · indicatie ${eur(isde.isde_amount)}` : ""}.
        Uw antwoorden zijn alvast ingevuld; controleer ze gerust.
      </p>
    </div>
    <button type="button" onClick={onRemove} data-testid="wizard-isde-unlink" aria-label="Subsidiecheck niet meesturen"
      className="inline-flex shrink-0 items-center gap-1 rounded-lg px-2 py-1.5 text-[13px] font-semibold text-slate-500 hover:bg-white hover:text-ink">
      <X className="h-4 w-4" aria-hidden="true" /> <span className="hidden sm:inline">Niet meesturen</span>
    </button>
  </div>
);
